import React from 'react';
import {
    priceCandleCloseTooltip,
    priceCandleHighTooltip,
    priceCandleLowTooltip,
    priceCandleOpenTooltip,
} from 'widgets/fillsGraph/orderFills/help/orderFillsLegendTooltip';
import { LegendData } from './orderFillsChartLegendData';
import classNames from 'classnames';
import TimeSeriesLegend from 'utils/components/TimeSeriesChart/TimeSeriesLegend';

interface OrderFillsChartPriceCandleLegendProps {
    fillsGraphContainerLeft: number;
    legendData: LegendData;
}

export function OrderFillsChartPriceCandleLegend(
    props: OrderFillsChartPriceCandleLegendProps
) {
    const { fillsGraphContainerLeft, legendData } = props;

    const direction =
        legendData.close === undefined || legendData.open === undefined
            ? ''
            : legendData.close > legendData.open
            ? 'up'
            : legendData.close < legendData.open
            ? 'down'
            : '';
    const cssClasses = classNames(
        'OrderFillsChartPriceCandleLegend',
        direction
    );

    if (
        legendData.open === '' &&
        legendData.high === '' &&
        legendData.low === '' &&
        legendData.close === ''
    ) {
        return <></>;
    }

    return (
        <div className={cssClasses}>
            <TimeSeriesLegend
                className="candle-open"
                label="Open"
                value={legendData.open}
                containerLeft={fillsGraphContainerLeft}
                tooltip={priceCandleOpenTooltip}
            />
            <TimeSeriesLegend
                className="candle-high"
                label="High"
                containerLeft={fillsGraphContainerLeft}
                value={legendData.high}
                tooltip={priceCandleHighTooltip}
            />
            <TimeSeriesLegend
                className="candle-low"
                label="Low"
                containerLeft={fillsGraphContainerLeft}
                value={legendData.low}
                tooltip={priceCandleLowTooltip}
            />
            <TimeSeriesLegend
                className="candle-close"
                label="Close"
                containerLeft={fillsGraphContainerLeft}
                value={legendData.close}
                tooltip={priceCandleCloseTooltip}
            />
        </div>
    );
}
